import { render, staticRenderFns } from "./client-activities-container.vue?vue&type=template&id=36bae0ea"
import script from "./client-activities-container.vue?vue&type=script&lang=js"
export * from "./client-activities-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports